var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.cbc74395be6cc0d1cf648a3bb76c9f6b.js */ "./node_modules/.federation/entry.cbc74395be6cc0d1cf648a3bb76c9f6b.js");
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};